import { render, staticRenderFns } from "./QuestionConfigurations.vue?vue&type=template&id=00f2c4d8&scoped=true"
import script from "./QuestionConfigurations.vue?vue&type=script&lang=js"
export * from "./QuestionConfigurations.vue?vue&type=script&lang=js"
import style0 from "./QuestionConfigurations.vue?vue&type=style&index=0&id=00f2c4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2c4d8",
  null
  
)

export default component.exports